require('./ctxTableSelection.style.scss');

class CtxTableSelectionController {
    constructor($scope) {
        this.$scope = $scope;
    }
    $onChanges(changesObj){
        if (changesObj.selectionController.currentValue) {
            this.setSelectionString();
        }
    }
    setSelectionString() {
        this.selectedNumber = this.selectionController.selectedItems ? this.selectionController.selectedItems.length : 0;
        // this.totalEntities = this.selectionController. ? this.state.pageSize : 0;
    }
}

const ctxTableSelectionComponent = {
    controller: CtxTableSelectionController,
    scope: {},
    template: require('./ctxTableSelection.template.html'),
    bindings: {
        selectionController: '<'
    }
};

CtxTableSelectionController.$inject = ['$scope'];

module.exports = ctxTableSelectionComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTableSelection/ctxTableSelection.component.js